/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSettings$Json } from '../fn/front-end-settings/get-settings-json';
import { GetSettings$Json$Params } from '../fn/front-end-settings/get-settings-json';
import { getSettings$Plain } from '../fn/front-end-settings/get-settings-plain';
import { GetSettings$Plain$Params } from '../fn/front-end-settings/get-settings-plain';
import { IpitFrontEndSettings } from '../models/ipit-front-end-settings';

@Injectable({ providedIn: 'root' })
export class FrontEndSettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSettings()` */
  static readonly GetSettingsPath = '/FrontEndSettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettings$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Plain$Response(params?: GetSettings$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<IpitFrontEndSettings>> {
    return getSettings$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettings$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Plain(params?: GetSettings$Plain$Params, context?: HttpContext): Observable<IpitFrontEndSettings> {
    return this.getSettings$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<IpitFrontEndSettings>): IpitFrontEndSettings => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettings$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Json$Response(params?: GetSettings$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<IpitFrontEndSettings>> {
    return getSettings$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettings$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettings$Json(params?: GetSettings$Json$Params, context?: HttpContext): Observable<IpitFrontEndSettings> {
    return this.getSettings$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<IpitFrontEndSettings>): IpitFrontEndSettings => r.body)
    );
  }

}
